/* __next_internal_client_entry_do_not_use__ GlobalPopup,RenderImportModal auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./index.module.scss";
import LOGO from "./assets/logo.svg?raw";
import ARROW from "./assets/arrow.svg?raw";
import { NewBaseIcon } from "../common/NewBaseIcon";
import { Translate } from "../topic/Translate";
import { createRoot } from "react-dom/client";
import { NextIntlClientProvider } from "next-intl";
export const GlobalPopup = param => {
  let {
    onClose,
    onOpenApp
  } = param;
  // 点击遮罩关闭
  const handleMaskClick = e => {
    var _document_querySelector_click,
      // 不影响现有modal逻辑，直接关闭导流弹窗时强制卸载arco蒙版
      _document_querySelector;
    if (e.target === e.currentTarget) {
      onClose === null || onClose === void 0 ? void 0 : onClose(true);
    }
    (_document_querySelector = document.querySelector(".arco-masking-mask")) === null || _document_querySelector === void 0 ? void 0 : (_document_querySelector_click = _document_querySelector.click) === null || _document_querySelector_click === void 0 ? void 0 : _document_querySelector_click.call(_document_querySelector);
  };
  // 处理打开应用
  const handleOpenApp = () => {
    onOpenApp === null || onOpenApp === void 0 ? void 0 : onOpenApp();
    onClose === null || onClose === void 0 ? void 0 : onClose();
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.mask,
    onClick: handleMaskClick,
    children: /*#__PURE__*/_jsx("div", {
      className: styles.popup,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.content,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.appIcon,
          children: /*#__PURE__*/_jsx("div", {
            className: styles.iconGradient,
            children: /*#__PURE__*/_jsx(NewBaseIcon, {
              icon: LOGO,
              style: {
                width: "100%",
                height: "100%",
                visibility: "hidden"
              }
            })
          })
        }), /*#__PURE__*/_jsxs("p", {
          className: styles.title,
          children: [/*#__PURE__*/_jsx(Translate, {
            translateKey: "GlobalPopupNew_Title_Prefix"
          }), /*#__PURE__*/_jsx("span", {
            children: "\uD83D\uDD1E"
          }), /*#__PURE__*/_jsx(Translate, {
            translateKey: "GlobalPopupNew_Title_Suffix"
          })]
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: /*#__PURE__*/_jsx(Translate, {
            translateKey: "GlobalPopupNew_Des"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.features,
          children: [/*#__PURE__*/_jsxs("div", {
            className: styles.featureItem,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.checkmark,
              children: /*#__PURE__*/_jsx(NewBaseIcon, {
                icon: ARROW
              })
            }), /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(Translate, {
                translateKey: "GlobalPopupNew_List_One"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.featureItem,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.checkmark,
              children: /*#__PURE__*/_jsx(NewBaseIcon, {
                icon: ARROW
              })
            }), /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(Translate, {
                translateKey: "GlobalPopupNew_List_Two"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.featureItem,
            children: [/*#__PURE__*/_jsx("span", {
              className: styles.checkmark,
              children: /*#__PURE__*/_jsx(NewBaseIcon, {
                icon: ARROW
              })
            }), /*#__PURE__*/_jsx("span", {
              children: /*#__PURE__*/_jsx(Translate, {
                translateKey: "GlobalPopupNew_List_Three"
              })
            })]
          })]
        }), /*#__PURE__*/_jsx("button", {
          className: styles.openAppBtn,
          onClick: handleOpenApp,
          children: /*#__PURE__*/_jsx(Translate, {
            translateKey: "GlobalPopupNew_Open_Button"
          })
        }), /*#__PURE__*/_jsx("button", {
          className: styles.laterBtn,
          onClick: () => {
            onClose(true);
          },
          children: /*#__PURE__*/_jsx(Translate, {
            translateKey: "GlobalPopup_button_later"
          })
        })]
      })
    })
  });
};
// 渲染引导弹窗
export const RenderImportModal = async function () {
  let {
    onOpen,
    onClose,
    beforeOpenModal,
    messages,
    locale
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  beforeOpenModal === null || beforeOpenModal === void 0 ? void 0 : beforeOpenModal();
  const containerId = "__global_h5import_popup__";
  let container = document.getElementById(containerId);
  if (container) return; // 防止重复显示
  container = document.createElement("div");
  container.id = containerId;
  // 绝对定位到最顶层
  Object.assign(container.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    zIndex: "2147483647"
  });
  document.body.appendChild(container);
  let root = createRoot(container);
  const handleClose = async function () {
    let isClickClose = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    try {
      root === null || root === void 0 ? void 0 : root.unmount();
    } finally {
      container && container.parentNode && container.parentNode.removeChild(container);
      root = null;
    }
    // 只有手动关闭时触发onClose
    isClickClose && (onClose === null || onClose === void 0 ? void 0 : onClose());
  };
  const handleOpenApp = async () => {
    onOpen === null || onOpen === void 0 ? void 0 : onOpen();
  };
  const element = messages ? /*#__PURE__*/_jsx(NextIntlClientProvider, {
    messages: messages,
    locale: locale,
    children: /*#__PURE__*/_jsx(GlobalPopup, {
      onClose: handleClose,
      onOpenApp: handleOpenApp
    })
  }) : /*#__PURE__*/_jsx(GlobalPopup, {
    onClose: handleClose,
    onOpenApp: handleOpenApp
  });
  root.render(element);
};